import { Link, useLocation } from 'react-router-dom';

import { cn } from '../../lib/cn';
import { useToast } from '../Toast';
import { isNavItemActive, type NavItem } from './navItems';
import styles from './Sidebar.module.css';

interface Props {
  item: NavItem;
  onNavigate?: () => void;
}

export function SidebarItem({ item, onNavigate }: Props) {
  const Icon = item.icon;
  const toast = useToast();
  const { pathname } = useLocation();

  if (!item.enabled) {
    return (
      <button
        type="button"
        className={cn(styles.item, styles.disabled)}
        title={`זמין ב-Phase ${String(item.phase)}`}
        aria-disabled="true"
        onClick={(e) => {
          e.preventDefault();
          toast.info(`זמין ב-Phase ${String(item.phase)}`);
        }}
      >
        <Icon size={18} className={styles.itemIcon} aria-hidden="true" />
        <span className={styles.itemLabel}>{item.label}</span>
        <span className={styles.itemBadge}>P{String(item.phase)}</span>
      </button>
    );
  }

  // A plain Link with active state computed here, not NavLink: an item like
  // "ניהול לקוח" owns several top-level paths, and NavLink only knows its `to`
  // (it would also overwrite aria-current with its own answer).
  const active = isNavItemActive(item, pathname);

  return (
    <Link
      to={item.path}
      className={cn(styles.item, active && styles.active)}
      aria-current={active ? 'page' : undefined}
      onClick={onNavigate}
    >
      <Icon size={18} className={styles.itemIcon} aria-hidden="true" />
      <span className={styles.itemLabel}>{item.label}</span>
      {item.wip ? (
        <span className={styles.itemBadge} title="הדף נפתח, התוכן עוד נבנה">
          בבנייה
        </span>
      ) : null}
    </Link>
  );
}
